import { Component, OnInit ,AfterViewInit } from '@angular/core';
import {FormGroup,FormBuilder,Validators} from '@angular/forms';
import {DataService} from '../data.service';
import {PasswordValidation} from '../password-validation';
import {Router} from '@angular/router';
import {HomeComponent} from '../home/home.component';

declare var $:any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit,AfterViewInit {
  passwordForm:FormGroup;
  Password:boolean=true;
  confirmPassword:boolean=true;
  oldPassword:boolean=true;
  isChangePassword:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  constructor(private fb:FormBuilder,private service:DataService,private router:Router,private home:HomeComponent) {
    this.passwordForm=this.fb.group({
      'email':['',Validators.compose([Validators.required,Validators.email])],
      'old-password':['',Validators.required],
      'password':['',Validators.required],
      'confirm-password':['',Validators.required]
    },
    {
      validator:PasswordValidation.MatchPassword
    }
  )

   }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  ngAfterViewInit() {
      $(window).scrollTop(0);
    $('.cd-header').css('backgroundColor','#941246');
  }

  changePassword(form){
    this.validateFormFields;
    if(!form.valid){
      if(!form.controls['email'].valid){
        if(!form.controls['email'].hasError('required')){
          this.service.alert('Please enter your email','error');
        } else {
            this.service.alert('Invalid email format','error');
        }
        return false;
      }
      if(!form.controls['old-password'].valid){
        this.service.alert('Please enter your temporary password','error');
        return false
      }
      if(!form.controls['password'].valid){
        this.service.alert('Please enter your password','error');
        return false
      }

      if(!form.controls['confirm-password'].valid){
        if(form.controls['confirm-password'].hasError('required')){
            this.service.alert('Please confirm your password','error');
        } else {
            this.service.alert("Confirm password and password doesn't match",'error');
        }
        return false;
      }

    } else {
      const inputJson={
      	"EmailID":form.value['email'],
      	"NewPwd":form.value['password'],
      	"Pwd":form.value['old-password']
      }
     // console.log(inputJson);
      this.service.UpdateUserPassword(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.service.alert('Password changed successfully','success');
            this.router.navigate(['/login']);
          } else {
            this.service.alert(result['Message'],'error');
          }
        },
        (error)=>{
         // console.log(error);
        }
      )
    }

  }

  togglePassword(){
    this.Password=!this.Password;
  }

  toggleOldPassword(){
    this.oldPassword=!this.oldPassword;
  }

  toggleConfirmPassword(){
    this.confirmPassword=!this.confirmPassword;
  }

  validateFormFields(form:FormGroup){
    (<any>Object).values(form.controls).forEach(control => {
        control.markAsTouched();
        if(control.controls){
          control.controls.forEach(c => {
              this.validateFormFields(c);
          });
        }
    });
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }


}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/change-password/change-password.component.ts